module.exports = { id: "google-plus", url: "/build/app/img/symbols.svg#google-plus", viewBox: "", toString: function() { return this.url; } };